import { render, staticRenderFns } from "./SaidAboutUs.vue?vue&type=template&id=55fb6164&"
import script from "./SaidAboutUs.vue?vue&type=script&lang=js&"
export * from "./SaidAboutUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports